import CenteredSpinner from "@/components/CenteredSpinner";
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import { useTranslation } from "react-i18next";
import CustomViews from "./customViews/CustomViews";
import DisplayModeSelector from "./DisplayModeSelector";
import Widgets from "./widgets/Widgets";

const HomepageSettings = () => {
    const { t } = useTranslation();
    const { isLoading: isLoadingUserProfile } = useGetUserProfile();

    if (isLoadingUserProfile) {
        return <CenteredSpinner />;
    }

    return (
        <div className="flex flex-col gap-8">
            <DialogHeader>
                <DialogTitle className="font-bold leading-none">
                    {t("settings.homepage.title")}
                </DialogTitle>
                <p className="text-xs">{t("settings.homepage.description")}</p>
            </DialogHeader>

            <DisplayModeSelector />
            <Widgets />
            <CustomViews />
        </div>
    );
};

export default HomepageSettings;
